import type { DashboardStats } from './types';
import { PluginMetricCards, type PluginMetricCardItem } from '@/app/components/PluginMetricCards';
import { FileText, Send, CheckCircle2, ShieldCheck } from 'lucide-react';

interface Props {
  stats: DashboardStats | null;
  loading: boolean;
}

const cards = [
  { key: 'totalEntries' as const, label: 'Audit-Einträge', icon: FileText, bgClass: 'bg-accent', iconClass: 'text-accent-foreground' },
  { key: 'pendingApprovals' as const, label: 'Offene Reviews', icon: Send, bgClass: 'bg-[hsl(var(--status-warning)/0.15)]', iconClass: 'text-[hsl(var(--status-warning))]' },
  { key: 'approvedWeek' as const, label: 'Genehmigt (7d)', icon: CheckCircle2, bgClass: 'bg-[hsl(var(--status-ok)/0.15)]', iconClass: 'text-[hsl(var(--status-ok))]' },
  { key: 'activePolicies' as const, label: 'Aktive Policies', icon: ShieldCheck, bgClass: 'bg-accent', iconClass: 'text-accent-foreground' },
] as const;

export function GovernanceStatCards({ stats, loading }: Props) {
  const items: PluginMetricCardItem[] = cards.map(({ key, label, icon }) => {
    const tone: PluginMetricCardItem['tone'] = key === 'pendingApprovals'
      ? 'warning'
      : key === 'approvedWeek'
        ? 'success'
        : 'neutral';

    return {
      id: key,
      label,
      icon,
      value: stats?.[key] ?? 0,
      tone,
    };
  });

  return (
    <PluginMetricCards items={items} loading={loading} />
  );
}
